document.addEventListener('DOMContentLoaded', function () {
  if (!window.mz) {
    return;
  }
  if (mz.context.filterShow) {
    // placeholder
  }
  document.addEventListener('on:quickbuy:after-open', () => {
    if (!window.mz || !window.mz.track) {
      return;
    }
    Array.from(
      document.querySelectorAll('.form.js-product-form .btn.btn--large')
    ).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var form = btn.form;
        if (!form) {
          return;
        }
        var uid = form.getAttribute('data-product-id');
        if (uid) {
          window.mz.track('add2cart', { uid: uid });
        }
      });
    });
  });

  var loadMoreFocusCardIndex = null;

  function getMezereonProductCards() {
    var grid = document.querySelector(
      '.mezereon .mz-hits-grid, .mezereon .mz-hits .product-grid',
    );
    if (!grid) {
      return [];
    }
    return Array.from(grid.querySelectorAll('product-block, .product-block'));
  }

  function focusMezereonCard(card) {
    if (!card) {
      return;
    }
    var target =
      card.querySelector('a.product-link') ||
      card.querySelector('.product-block__title a');
    if (!target) {
      target = card;
      if (!card.hasAttribute('tabindex')) {
        card.setAttribute('tabindex', '-1');
      }
    }
    if (target && typeof target.focus === 'function') {
      target.focus();
    }
  }

  function focusFirstNewlyLoadedCard() {
    if (loadMoreFocusCardIndex === null) {
      return;
    }
    var index = loadMoreFocusCardIndex;
    loadMoreFocusCardIndex = null;
    var cards = getMezereonProductCards();
    var card = cards[index];
    if (!card) {
      return;
    }
    requestAnimationFrame(function () {
      focusMezereonCard(card);
    });
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) {
        return;
      }
      var loadMoreBtn = e.target.closest('.mz-paging-more button');
      if (!loadMoreBtn) {
        return;
      }
      loadMoreFocusCardIndex = getMezereonProductCards().length;
    },
    true,
  );

  function closeHeaderSearch() {
    if (!document.body.classList.contains('show-search')) {
      return;
    }

    var searchCloseButton = document.querySelector('.main-search__close');
    if (searchCloseButton) {
      searchCloseButton.click();
      return;
    }

    document.body.classList.remove('show-search');
  }

  function isMzAutocompletePanelInteraction(target) {
    return !!target.closest('#mz-autocomplete .mz-autocomplete-container');
  }

  function isMzAutocompleteDismissControl(target) {
    return !!target.closest('.mz-autocomplete-close, [aria-label="close autocomplete"]');
  }

  function bindHeaderSearchCloseTriggers() {
    // Close the theme search banner only for clicks outside the combined
    // main-search + MZ autocomplete experience — not for in-panel actions
    // such as list/grid toggles, suggestions, or product links.
    document.addEventListener(
      'click',
      function (e) {
        if (!document.body.classList.contains('show-search')) {
          return;
        }
        if (!e.target || !e.target.closest) {
          return;
        }
        if (e.target.closest('.main-search')) {
          return;
        }
        if (isMzAutocompletePanelInteraction(e.target)) {
          return;
        }
        closeHeaderSearch();
      },
      true,
    );

    document.addEventListener(
      'submit',
      function (e) {
        if (!document.body.classList.contains('show-search')) {
          return;
        }
        if (!e.target || !e.target.closest) {
          return;
        }
        if (!e.target.closest('.main-search__form')) {
          return;
        }
        closeHeaderSearch();
      },
      true,
    );
  }

  function afterUpdate() {
    closeHeaderSearch();

    const quickbuyCloseButton = document.querySelector(
      '.expanded .quickbuy-container .close-detail'
    );
    if (quickbuyCloseButton) {
      if (typeof window.observer !== 'undefined') {
        quickbuyCloseButton.click();
      }
    }
    const loadMoreButton = document.querySelector('.mz-paging-more button');
    if (loadMoreButton) {
      loadMoreButton.classList.add('btn');
    }

    focusFirstNewlyLoadedCard();

    document.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
  }

  // Space/Enter support for filter toggles and drawer close.
  document.addEventListener('keydown', function (e) {
    if (e.key !== ' ' && e.code !== 'Space' && e.key !== 'Enter') return;

    var el = e.target.closest('a.toggle-btn, .mz-filter-btn, .ch-drawer__close-btn');
    if (!el) return;

    // Native <a> tags handle Enter; only intercept Space for them.
    if (el.tagName === 'A' && e.key === 'Enter') return;

    e.preventDefault();
    var clickTarget = el.querySelector('a.mz-filter') || el;
    clickTarget.click();
  });

  bindHeaderSearchCloseTriggers();

  if (mz.app && mz.app.$bus) {
    // Fires as soon as MZ starts a search query — before after-query / after-update.
    mz.app.$bus.on('run-query', closeHeaderSearch);
    mz.app.$bus.on('after-update', afterUpdate);

    var mzFilterOpener = null;
    mz.app.$bus.on('toggle-portal-nav', function (isOpen) {
      if (isOpen) {
        mzFilterOpener = document.activeElement;
        setTimeout(function () {
          var closeBtn = document.querySelector('.mz-drawer .ch-drawer__close-btn');
          if (closeBtn) {
            closeBtn.tabIndex = 0;
            closeBtn.focus();
          }
        }, 500);
      } else {
        if (mzFilterOpener) mzFilterOpener.focus();
        mzFilterOpener = null;
      }
    });
  }
});

// filter visibility
toggleFilter = function (el) {
  var aggs = document.querySelector('.mz-results');
  if (!aggs) {
    return false;
  }
  var isCollapsed = aggs.classList.toggle('mz-collapsed-filter');

  if (el && el.setAttribute) {
    el.setAttribute('aria-expanded', !isCollapsed);
  }

  return false;
};
